// Create a custom hook - put this in a separate file like hooks/useActiveRestaurant.js
import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { activeRestaurantState } from '../recoil';
import { activeEnvironment } from '../config';

export const useActiveRestaurant = () => {
    const [activeRestaurant, setActiveRestaurant] = useRecoilState(activeRestaurantState);
    
    // Initialize from localStorage on first load
    useEffect(() => {
        if (!activeRestaurant?.uniqueIdentificationToken) {
            try {
                const storedRestaurant = localStorage.getItem(activeEnvironment + '_activeRestaurant');
                if (storedRestaurant) {
                    const parsedRestaurant = JSON.parse(storedRestaurant);
                    if (parsedRestaurant?.uniqueIdentificationToken) {
                        setActiveRestaurant(parsedRestaurant);
                    }
                }
            } catch (error) {
                console.error('Error parsing stored restaurant:', error);
                // Clear invalid data
                localStorage.removeItem(activeEnvironment + '_activeRestaurant');
            }
        }
    }, [activeRestaurant, setActiveRestaurant]);

    // Sync to localStorage when state changes
    useEffect(() => {
        if (activeRestaurant?.uniqueIdentificationToken) {
            try {
                localStorage.setItem(
                    activeEnvironment + '_activeRestaurant', 
                    JSON.stringify(activeRestaurant)
                );
            } catch (error) {
                console.error('Error storing restaurant to localStorage:', error);
            }
        }
    }, [activeRestaurant]);

    return {
        activeRestaurant,
        setActiveRestaurant,
        hasActiveRestaurant: Boolean(activeRestaurant?.uniqueIdentificationToken),
        restaurantId: activeRestaurant?.uniqueIdentificationToken || null
    };
};